var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{class:[
        `font-extrabold text-transparent text-3xl md:text-4xl bg-clip-text
        bg-gradient-to-r from-${_vm.colorScheme}-600 to-${_vm.colorScheme}-400 pb-px`
    ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }